import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="py-16 bg-stone-950 border-t border-stone-800" data-id="element-907">
      <div className="max-w-6xl mx-auto px-6" data-id="element-908">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-909">
          {/* Brand */}
          <div className="md:col-span-4" data-id="element-910">
            <p className="font-serif text-xl text-stone-50 mb-4" data-id="element-911">BlockQuote</p>
            <p className="text-stone-400 max-w-sm leading-relaxed" data-id="element-912">
              Instant group quotes. One-click holds. Direct resort pricing. The
              infrastructure layer for group travel.
            </p>
          </div>

          {/* Platform */}
          <div className="md:col-span-2" data-id="element-913">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-914">
              Platform
            </p>
            <ul className="space-y-3" data-id="element-915">
              <li data-id="element-916">
                <button onClick={() => scrollTo('features')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-917">
                  Product
                </button>
              </li>
              <li data-id="element-918">
                <button onClick={() => scrollTo('pricing')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-919">
                  Pricing
                </button>
              </li>
              <li data-id="element-920">
                <button onClick={() => scrollTo('proof')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-921">
                  Case Study
                </button>
              </li>
            </ul>
          </div>

          {/* Demos */}
          <div className="md:col-span-3" data-id="element-922">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-923">
              Live Demos
            </p>
            <ul className="space-y-3" data-id="element-924">
              <li data-id="element-925">
                <Link to="/app" className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-926">
                  Resort Dashboard
                </Link>
              </li>
              <li data-id="element-927">
                <Link to="/agency" className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-928">
                  Agency Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-3" data-id="element-929">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-930">
              Company
            </p>
            <ul className="space-y-3" data-id="element-931">
              <li data-id="element-932">
                <Link to="/deck" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-933">
                  Pitch Deck
                </Link>
              </li>
              <li data-id="element-934">
                <Link to="/sales" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-935">
                  Resort Sales Deck
                  <span className="font-mono text-[10px] text-red-600 border border-red-600/30 px-1.5 py-0.5" data-id="element-936">
                    NEW
                  </span>
                </Link>
              </li>
              <li data-id="element-937">
                <button onClick={() => scrollTo('cta')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-938">
                  Request Pilot
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-stone-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-939">
          <p className="font-mono text-xs text-stone-500" data-id="element-940">
            © 2026 BlockQuote. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-941">
            <span className="font-mono text-xs text-stone-500 hover:text-stone-400 cursor-pointer transition-colors" data-id="element-942">
              Privacy
            </span>
            <span className="font-mono text-xs text-stone-500 hover:text-stone-400 cursor-pointer transition-colors" data-id="element-943">
              Terms
            </span>
          </div>
        </div>
      </div>
    </footer>;
}